import { TIER2_GRADE_BAND_KEYS } from 'store/reportsManager/constants'

export const DEFAULT_GRADE_BANDS = [
  {
    gradeBand: TIER2_GRADE_BAND_KEYS.K_2,
    lessonsCompleted: 0,
    groupsCount: 0,
    lessonsCompletedByUnit: {
      1: 0,
      2: 0,
      3: 0,
    },
  },
  {
    gradeBand: TIER2_GRADE_BAND_KEYS.THREE_5,
    lessonsCompleted: 0,
    groupsCount: 0,
    lessonsCompletedByUnit: {
      1: 0,
      2: 0,
      3: 0,
    },
  },
  {
    gradeBand: TIER2_GRADE_BAND_KEYS.SIX_8,
    lessonsCompleted: 0,
    groupsCount: 0,
    lessonsCompletedByUnit: {
      1: 0,
      2: 0,
      3: 0,
    },
  },
]

export const LESSON_COMPLETION_LINK_TEXT = 'See Lesson Completion by Group'
export const LESSON_COMPLETION_PATH =
  '/admin/program/k8/small-group-lesson-completion/'
